<template>
  <div>
    <a class="btn btn-primary btn-sm" type="button" id="gridAction" aria-expanded="false" @click.prevent="viewBody">
      View
    </a>
    <ees-dialog ref="viewDialog" :title="params.data.subject" :dialog-id="params.data.notificationId + 'modal'">
      <div v-html="params.data.body"></div>
    </ees-dialog>
  </div>
</template>

<script lang="js">
import Vue from 'vue'
import EesDialog from "@/modules/ees/components/Dialog.vue"

export default Vue.extend({
  components: { EesDialog },
  methods: {
    viewBody: function () {
      this.$refs.viewDialog.prompt(() => { console.log('viewDialog') })
    },
  }
})
</script>
